import React from 'react';
let TemplateContext;
let { Provider } = (TemplateContext = React.createContext())
export const useTemplate = () => React.useContext(TemplateContext)
export default function Template(props) { 
    return <Provider value={props.value}>{props.children}</Provider>
}
